import type Controller from '@ember/controller'
import Route from '@ember/routing/route'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'

export default class extends Route {
  queryParams = {
    sort: {
      replace: true,
    },
    tab: {
      replace: true,
    },
    rule: {
      replace: true,
    },
    pageNumber: {
      replace: true,
    },
    student: {
      replace: true,
    },
  }

  model() {
    const { scopedData, uiScope, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    return {
      uiScope,
      period,
      students: scopedData.students,
    }
  }

  setupController(controller: Controller, model: unknown) {
    super.setupController(controller, model)
    controller.set('rule', '')
    controller.set('student', '')
  }
}
